export class LanguageText {
    constructor(langCode) {
        if (langCode === undefined) {
            throw new Error('must pass a supported language code; either "ES" (Espanol) or "EN" (English)');
        }
        console.log("LanguageTextUsing Language: " + this.Language);
        this.langCode = langCode;
    }
    get Yes() {
        switch (this.langCode) {
            case 'ES':
                return "Si"
            default:
                return "Yes"
        }
    }
    get No(){
        switch (this.langCode) {
            case 'ES':
                return "No"
            default:
                return "No"
        }
    }
    get Unsure(){
        switch (this.langCode) {
            case 'ES':
                return "No Seguro"
            default:
                return "Unsure"
        }
    }
    get LessThanOneDay(){
        switch (this.langCode) {
            case 'ES':
                return "Menos de 1 día"
            default:
                return "Less than 1 day"
        }
    }
    get OneToTwoDays(){
        switch (this.langCode) {
            case 'ES':
                return "1 a 2 días"
            default:
                return "1 - 2 days"
        }
    }
    get ThreeToFourDays(){
        switch (this.langCode) {
            case 'ES':
                return "3 a 4 días"
            default:
                return "3 - 4 days"
        }
    }
    get FiveToSevenDays(){
        switch (this.langCode) {
            case 'ES':
                return "5 a 7 días"
            default:
                return "5 - 7 days"
        }
    }
    get EducationLevelPrompt(){
        switch (this.langCode) {
            case 'ES':
                return "¿Cuál es su nivel educativo más alto? (Por favor, seleccione su nivel de educación)"
            default:
                return "Please select your education level"
        }
    }
    get NoFormalEducation(){
        switch (this.langCode) {
            case 'ES':
                return "Sin educación formal"
            default:
                return "No formal education"
        }
    }
    get GED(){
        switch (this.langCode) {
            case 'ES':
                return "Educación Intermedia / Educación secundaria/ GED"
            default:
                return "Secondary education / GED"
        }
    }
    get PrimaryEducation(){
        switch (this.langCode) {
            case 'ES':
                return "Educación Primaria"
            default:
                return "Primary / elementary education"
        }
    }
    get College(){
        switch (this.langCode) {
            case 'ES':
                return "*Some* Licenciatura"
            default:
                return "High school graduate / Some college / Associate’s degree"
        }
    }
    get Bachelor(){
        switch (this.langCode) {
            case 'ES':
                return "Licenciatura"
            default:
                return "Bachelor's degree"
        }
    }
    get Graduate(){
        switch (this.langCode) {
            case 'ES':
                return "Maestría / Doctorado"
            default:
                return "Master's / Doctorate degree"
        }
    }

    get Language(){
        switch (this.langCode) {
            case 'ES':
                return "Espanol"
            case 'EN':
                return "English"
            default:
                return "English (default)"
        }
    }
}


